module.exports = __webpack_public_path__ + "static/N2N6-13e1dda1190d19373cf9e8fff5d32d2b.jpg";